import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { selectBlockedDays } from '../../reducers/Organisation/reservationsReducer'

import { getBlockedDay } from './../../helpers/helpers'

class CalendarCell extends React.Component {
  render() {
    const { t } = this.props
    const date = this.props.value
    const today = new Date()
    let classes = 'ctp-calendar__cell'
    const isBlockedDay = getBlockedDay(date, this.props.blockedDays)

    if (moment(date).format('DD-MM-YYYY') === moment(today).format('DD-MM-YYYY')) {
      classes += ' ctp-calendar__cell--today'
    }
    if (isBlockedDay) {
      classes += ' ctp-calendar__cell--blocked'
    }

    return (
      <div className={classes} data-event-date={`${moment(date).format('DD-MM-YYYY')}`}>
        {isBlockedDay ? (
          <div className="ctp-calendar__cell-blocked">
            <span>{t('calendar:blockedDay')}</span>
          </div>
        ) : (
          <div className="ctp-calendar__cell-wrapper">
            <span>{moment(date).format('D')}</span>
            <span>{moment(date).format('MMMM')}</span>
            <span>{moment(date).format('dddd')}</span>
          </div>
        )}
      </div>
    )
  }
}

CalendarCell.propTypes = {
  value: PropTypes.object,
  blockedDays: PropTypes.array,
  t: PropTypes.func,
}

export default connect((state, _props) => ({ blockedDays: selectBlockedDays(state) }))(
  withTranslation(['calendar'])(CalendarCell),
)
